import { Component, Input, inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BrButton } from '@govbr-ds/webcomponents-angular/standalone';

/**
 * Diálogo de confirmação no padrão gov.br (br-modal). Fecha com `true` ao confirmar
 * e é dispensado ao cancelar. Quando `cancelLabel` é nulo, exibe só o botão de ação.
 */
@Component({
  selector: 'app-confirmacao-modal',
  standalone: true,
  imports: [CommonModule, BrButton],
  templateUrl: './confirmacao-modal.component.html',
  styleUrl: './confirmacao-modal.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConfirmacaoModalComponent {
  readonly activeModal = inject(NgbActiveModal);

  @Input() titulo = 'Confirmação';
  @Input() mensagem = '';
  @Input() confirmLabel = 'Confirmar';
  @Input() cancelLabel: string | null = 'Cancelar';
  /** `question` para confirmações; `warning` para avisos de um botão. */
  @Input() icone: 'question' | 'warning' = 'question';

  get partesMensagem(): { texto: string; destaque: boolean }[] {
    return this.mensagem
      .split(/(“[^”]*”)/)
      .filter((parte) => parte !== '')
      .map((parte) => ({ texto: parte, destaque: parte.startsWith('“') }));
  }

  confirmar(): void {
    this.activeModal.close(true);
  }
}
